module.exports = [{
      plugin: require('/Users/weeravit/Documents/reactjs-workspace/web-admin-aptnesshealth/node_modules/gatsby-plugin-material-ui/gatsby-browser.js'),
      options: {"plugins":[],"stylesProvider":{"injectFirst":true}},
    },{
      plugin: require('/Users/weeravit/Documents/reactjs-workspace/web-admin-aptnesshealth/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
